/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const SystemConfigTestEmailPost = {
  id: 'system-config.test-email.post',
  tag: 'Common',
  summary: 'Test email send feature',
  description: 'Test email send VIA SMTP',
  method: 'post',
  flags: { isSuperuser: true, isAuthorized: true },
  route: () => `/system-config/test-email`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            email: z.string().min(1).email(),
            subject: ZodTypes.TrimmedString.min(1),
            html: ZodTypes.TrimmedString.min(1),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
